import { Button, Col, DatePicker, Form, Modal, Row, Select } from 'antd';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getBoxWorkStatus, getBoxWorkType, getOnlyPersonInOrg } from 'app/entities/common/common.reducer';
import { getEntities as getFields } from 'app/entities/field/field.reducer';
import { getEntities as getProjects } from 'app/entities/project/project.reducer';
import React, { useEffect } from 'react';
import './style.scss';
import { setFilterObjective } from 'app/entities/filters/filters.reducer';
import dayjs from 'dayjs';

type IFilterProps = {
  visible: boolean;
  onCancel: (data: any) => void;
};

const FilterModal = ({ visible, onCancel }: IFilterProps) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const workTypeList = useAppSelector(state => state.common.workType);
  const projectList = useAppSelector(state => state.project.entities);
  const employeeList = useAppSelector(state => state.common.personPositions);
  const fieldList = useAppSelector(state => state.field.entities);
  const workStatusList = useAppSelector(state => state.common.workStatus);
  const filters = useAppSelector(state => state.filters.objective);
  const filtersCheckIn = useAppSelector(state => state.filters.orgCheckIn);

  useEffect(() => {
    innitData();
  }, []);

  useEffect(() => {
    if (filters) {
      form.setFieldsValue({
        ...filters,
        startDate: filters.startDate && dayjs(filters.startDate),
        dueDate: filters.dueDate && dayjs(filters.dueDate),
      });
    }
    else if (filtersCheckIn) {
      form.setFieldsValue({
        ...filtersCheckIn,
        startDate: filtersCheckIn.startDate && dayjs(filtersCheckIn.startDate),
        dueDate: filtersCheckIn.dueDate && dayjs(filtersCheckIn.dueDate),
      });
    }
  }, [filters, filtersCheckIn]);

  const innitData = () => {
    dispatch(getBoxWorkType());
    dispatch(getBoxWorkStatus({}));
    dispatch(getFields({}));
    dispatch(getOnlyPersonInOrg());
    dispatch(getProjects({}));
  };

  const handleFilter = () => {
    form.validateFields().then(values => {
      handleClose(values);
    });
  };

  const handleClose = (values) => {
    onCancel(values);
  };

  const handleReset = () => {
    form.resetFields();
    handleFilter();
  };

  // Function to filter options based on the input value
  const filterOption = (inputValue, option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;

  return (
    <Modal
      width={500}
      className="modal-filter-custom"
      open={visible}
      maskClosable={false}
      footer={null}
      title="Bộ lọc tìm kiếm"
      onCancel={handleClose}
    >
      <Form size="large" form={form} onFinish={handleFilter} layout="vertical">
        <Row>
          <Col md={11}>
            <Form.Item label="Lĩnh vực" name="fieldValue">
              <Select
                mode="multiple"
                allowClear
                showSearch
                size="large"
                filterOption={filterOption}
                options={fieldList.map(x => {
                  return {
                    label: x.description,
                    value: x.value,
                  };
                })}
                placeholder="Chọn lĩnh vực"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Dự án" name="projectId">
              <Select
                mode="multiple"
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={projectList.map(x => {
                  return {
                    label: x.name,
                    value: x.id,
                  };
                })}
                placeholder="Chọn dự án"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <Form.Item label="Thực hiện chính KR" name="krAccountableId">
              <Select
                mode="multiple"
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={employeeList.map(x => {
                  return {
                    label: x.name,
                    value: x.id,
                  };
                })}
                placeholder="Chọn người thực hiện chính (PIC)"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Mảng công việc" name="workTypeId">
              <Select
                mode="multiple"
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workTypeList.map(x => {
                  return {
                    label: x.name,
                    value: x.id,
                  };
                })}
                placeholder="Chọn nhóm công việc"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item label="Tình trạng KR" name="workStatus">
              <Select
                mode="multiple"
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn tình trạng"
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Row className="action mt-3" justify="end">
            <Col>
              <Button
                onClick={() => {
                  handleReset();
                }}
                className="secondary"
                size="large"
              >
                Bỏ lọc
              </Button>
            </Col>
            <Col>
              <Button size="large" className="primary" htmlType="submit">
                Tìm kiếm
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FilterModal;
